export const CAMPAIGN_SETTING_SET_REQUEST = 'character.CAMPAIGN_SETTING_SET_REQUEST';
export const CAMPAIGN_SETTING_SET = 'character.CAMPAIGN_SETTING_SET';
export const CAMPAIGN_SETTING_SET_COMMIT = 'character.CAMPAIGN_SETTING_SET_COMMIT';
